import { HTTP } from '../../utils'

export const getPrivateFoldersWithOwner = () => {
  return HTTP().get('/learningspace/listLibrariesWithOwner')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const createPrivateFolder = (title) => {
  return HTTP().put('/learningspace/createInstitutionPrivateLibrary/' + title)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deletePrivateFolder = (uuid) => {
  return HTTP().delete('/learningspace/' + uuid)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getUsersForRole = (data) => {
  var url = '/user/search?parentSpaceId=' + data.parentSpaceId + '&role=' + data.role + '&page=' + data.page + '&count=' + data.count
  if (data.name) {
    url += '&name=' + data.name
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getEnrolledUsers = (parentSpaceId) => {
  var url = '/user/findUsersForLibrary?parentSpaceId=' + parentSpaceId + '&page=0&count=99999'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updateInstitutionPrivateFolder = (data) => {
  var url = '/learningspace/updateInstitutionPrivateLibrary/' + data.uuid
  return HTTP().put(url, data)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/folderManagement/api.js